import { useState } from 'react';
import { FaGithub, FaExternalLinkAlt, FaLock } from 'react-icons/fa';
import erpDashboard from '../assets/ERP.png';
import busbooking from '../assets/busbooking.png';
import hrms from '../assets/HRMS.png';
import firecrackers from '../assets/FIRECRACKERS.png';
import safetyapp from '../assets/SAFETY APP.jpg';
import aiInterview from '../assets/AI interview.png';
import aiHrms from '../assets/AI driven HRMS.png';
import project2 from '../assets/mini-ecom-home.png';
import project3 from '../assets/ecommerce-websites.jpg';
import project4 from '../assets/food-ecommerce.jpg';
import aiCodeReview from '../assets/ai-code-review.png';
import suba from '../assets/suba.png';

const workProjects = [
  {
    title: 'AI-Driven HRMS Platform',
    year: '2026',
    description:
      'Enterprise-grade multi-tenant HRMS with full AI automation — covers 12+ modules across the complete employee lifecycle with an AI Decision Engine, predictive attrition detection, sentiment analysis, NLP HR Copilot, and payroll anomaly detection.',
    image: aiHrms,
    tags: ['React', 'ASP.NET Core', 'SQL Server', 'AI Automation', 'SignalR', 'Multi-tenant', 'NLP'],
    featured: true,
    category: 'Full Stack',
    isPrivate: true,
  },
  {
    title: 'AI Interview Assessment Platform',
    year: '2026',
    description:
      'Developed an online interview system with admin-controlled email invitations for candidates. Implemented topic-based AI-generated and manually added questions. Integrated secure login with screen and video recording for test monitoring.',
    image: aiInterview,
    tags: ['ReactJS', '.NET', 'SQL Server', 'AI', 'REST APIs'],
    featured: true,
    category: 'Full Stack',
    isPrivate: true,
  },
  {
    title: 'ERP – Finance & Inventory Modules',
    year: '2026',
    description:
      'Developed finance and inventory modules using ReactJS and .NET with SQL Server integration. Designed RESTful APIs and validation logic for accurate transaction processing, stock management, and reporting.',
    image: erpDashboard,
    tags: ['ReactJS', '.NET', 'SQL Server', 'REST APIs'],
    featured: true,
    category: 'Full Stack',
    isPrivate: true,
  },
  {
    title: 'HRMS – Human Resource Management System',
    year: '2025',
    description:
      'Built attendance, payroll, and leave management modules with role-based authentication. Integrated frontend and backend services to automate employee data handling.',
    image: hrms,
    tags: ['ReactJS', '.NET', 'SQL Server', 'Role-based Auth'],
    featured: true,
    category: 'Full Stack',
    isPrivate: true,
  },
  {
    title: 'Fire Crackers E-Commerce Website',
    year: '2025',
    description:
      'Responsive e-commerce platform with product catalog, authentication, cart, and order management using ReactJS and .NET.',
    image: firecrackers,
    tags: ['ReactJS', '.NET', 'SQL Server', 'E-Commerce'],
    featured: false,
    category: 'Full Stack',
    isPrivate: true,
  },
  {
    title: 'Safety App – Airport & Seaport Employees',
    year: '2025',
    description:
      'React Native app for real-time employee incident reporting and alert notifications with secure API integration.',
    image: safetyapp,
    tags: ['React Native', 'REST APIs', 'Mobile', 'SQL Server'],
    featured: false,
    category: 'Mobile',
    isPrivate: true,
  },
];

const personalProjects = [
  {
    title: 'AI-Powered Code Review Assistant',
    year: '2026',
    description:
      'Full-stack AI tool where developers paste code and receive intelligent reviews covering bug detection, security vulnerabilities, performance issues, quality score, and auto-fix suggestions. Built with React, FastAPI (Python), Claude API, and SQL Server.',
    image: aiCodeReview,
    tags: ['React', 'Python', 'FastAPI', 'Claude AI', 'SQL Server', 'REST APIs'],
    github: 'https://github.com/atchu33/code-review-assistant.git',
    live: 'https://atchu33.github.io/code-review-assistant/',
    featured: true,
    category: 'Full Stack',
    isPrivate: false,
  },
  {
    title: 'Mini E-Commerce Website',
    year: '2025',
    description:
      'Responsive e-commerce platform built with ReactJS and Bootstrap featuring product listings, cart management, and MongoDB as the database.',
    image: project3,
    tags: ['React.js', 'Bootstrap', 'MongoDB', 'Node.js'],
    github: 'https://github.com/atchu33/Mini-ecommerce',
    live: '',
    featured: true,
    category: 'Full Stack',
    isPrivate: false,
  },
  {
    title: 'Scuba Diving Template Webpage',
    year: '2025',
    description:
      'A visually appealing website template built using HTML, CSS and JavaScript showcasing frontend design skills.',
    image: suba,
    tags: ['HTML', 'CSS', 'JavaScript'],
    github: 'https://github.com/atchu33/simple-diving-webpage',
    live: '',
    featured: false,
    category: 'Frontend',
    isPrivate: false,
  },
  {
    title: 'Online Bus Ticket Booking with Chatbot',
    year: '2024',
    description:
      'Full-featured bus booking system with an integrated chatbot for real-time tracking and automated ticket booking. Built with HTML, CSS, JavaScript, PHP and MySQL.',
    image: busbooking,
    tags: ['HTML', 'CSS', 'JavaScript', 'PHP', 'MySQL'],
    github: 'https://github.com/atchu33',
    live: '',
    featured: false,
    category: 'Full Stack',
    isPrivate: false,
  },
];

function ProjectCard({ project }) {
  return (
    <div className="project-card scroll-animate group">
      <div className="relative overflow-hidden h-48">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="project-overlay">
          {project.isPrivate ? (
            <span
              className="text-white text-sm font-medium px-4 py-2 rounded-xl flex items-center gap-2"
              style={{ background: 'rgba(0,0,0,0.75)', border: '1px solid rgba(255,255,255,0.1)' }}
            >
              <FaLock size={12} /> Private Project
            </span>
          ) : (
            <div className="flex gap-3">
              {project.github && (
                <a href={project.github} target="_blank" rel="noreferrer"
                  className="w-10 h-10 rounded-xl flex items-center justify-center text-white hover:scale-110 transition-all"
                  style={{ background: 'rgba(124,58,237,0.8)' }} aria-label="GitHub">
                  <FaGithub size={18} />
                </a>
              )}
              {project.live && (
                <a href={project.live} target="_blank" rel="noreferrer"
                  className="w-10 h-10 rounded-xl flex items-center justify-center text-white hover:scale-110 transition-all"
                  style={{ background: 'rgba(6,182,212,0.8)' }} aria-label="Live demo">
                  <FaExternalLinkAlt size={16} />
                </a>
              )}
            </div>
          )}
        </div>

        {project.current && (
          <div className="absolute top-3 left-3 text-xs px-2 py-1 rounded-full font-semibold text-white flex items-center gap-1"
            style={{ background: 'linear-gradient(135deg,#059669,#06b6d4)' }}>
            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" /> Current
          </div>
        )}
        {!project.current && project.featured && (
          <div className="absolute top-3 left-3 text-xs px-2 py-1 rounded-full font-semibold text-white"
            style={{ background: 'linear-gradient(135deg,#7c3aed,#06b6d4)' }}>
            Featured
          </div>
        )}
        <div className="absolute top-3 right-3 text-xs px-2 py-1 rounded-full"
          style={{ background: 'rgba(0,0,0,0.6)', color: '#94a3b8', border: '1px solid rgba(255,255,255,0.1)' }}>
          {project.category} · {project.year}
        </div>
      </div>

      <div className="p-5">
        <h3 className="text-lg font-bold text-white mb-2">{project.title}</h3>
        <p className="text-slate-400 text-sm leading-relaxed mb-4">{project.description}</p>
        <div className="flex flex-wrap gap-2 mb-4">
          {project.tags.map(tag => <span key={tag} className="tag">{tag}</span>)}
        </div>
        <div className="flex gap-3 pt-2 border-t border-white/5">
          {project.isPrivate ? (
            <span className="flex items-center gap-1.5 text-xs text-slate-500">
              <FaLock size={10} /> Private / Company Project
            </span>
          ) : (
            <>
              {project.github && (
                <a href={project.github} target="_blank" rel="noreferrer"
                  className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-violet-400 transition-colors">
                  <FaGithub size={14} /> Code
                </a>
              )}
              {project.live && (
                <a href={project.live} target="_blank" rel="noreferrer"
                  className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-cyan-400 transition-colors">
                  <FaExternalLinkAlt size={12} /> Live Demo
                </a>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Projects() {
  const [tab, setTab] = useState('work');

  return (
    <section id="projects" className="relative py-24 overflow-hidden">
      <div className="glow-orb w-80 h-80 bg-violet-600 -bottom-20 -right-20" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 scroll-animate">

          <h2 className="section-title gradient-text">Projects</h2>
          <div className="title-line" />
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-10 px-2">
          <div className="flex flex-col sm:flex-row rounded-xl p-1 gap-1 w-full sm:w-auto"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}>
            {[
              { key: 'work', label: '💼 Professional Projects' },
              { key: 'personal', label: '🚀 Personal Projects' },
            ].map(t => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 ${tab === t.key ? 'text-white' : 'text-slate-400 hover:text-white'
                  }`}
                style={tab === t.key ? { background: 'linear-gradient(135deg,#7c3aed,#06b6d4)' } : {}}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {(tab === 'work' ? workProjects : personalProjects).map((project, i) => (
            <ProjectCard key={project.title} project={project} index={i} />
          ))}
        </div>

        <div className="text-center mt-12 scroll-animate">
          <a href="https://github.com/atchu33" target="_blank" rel="noreferrer" className="btn-outline inline-flex">
            <FaGithub size={16} /> View All on GitHub
          </a>
        </div>
      </div>
    </section>
  );
}
